export const loadLanguageFile = () => import(`i2l?query=sporks!growth-onboarding-feedback-components/lang/en.lyaml`);